import styled from "styled-components";

export const ActionContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.hasReleaseVehicle && (props.hasVehicleInbound || props.hasRequestDock) ? `repeat(4, 1fr)` : `repeat(3, 1fr)`)};
  column-gap: 2px;
  > button {
    background: transparent;
    border: none;
    justify-content: flex-start;
    align-items: center;
    margin-right: auto;
    display: flex;
    color: ${(props) => props.theme.colors.text};
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .viewRegister,
  .vehicleActionRegister,
  .vehicleEntryAuthorization,
  .releaseVehicleActionRegister {
    cursor: pointer;
  }
  .vehicleEntryAuthorizationWithWarning {
    color: ${(props) => props.theme["@danger-color"]};
    cursor: pointer;
  }
  .vehicleStatusIcon {
    cursor: default;
  }

  .vehicleActionRegisterDisabled,
  .releaseVehicleActionRegisterDisabled {
    color: ${(props) => props.theme["@disabled-button"]};
    cursor: not-allowed;
  }
`;

export const AttendanceContainer = styled.div`
  margin-top: 5px;
  .ant-pagination {
    align-items: left;
    justify-content: left;
    display: flex;
    width: 100%;
    margin-top: 30px;
  }

  .ant-table-pagination.ant-pagination {
    margin-bottom: 0;
  }

  .ant-pagination-options {
    margin-left: auto;
  }
  .ant-pagination-total-text {
    margin-right: auto;
  }

  .ant-pagination-item {
    border: none;
  }
  .ant-pagination-item-link {
    border: none;
  }
`;

export const VehiclePlateContainer = styled.div`
  ${(props) =>
    !props.hasActiveTag &&
    `
      display: flex;
      gap: 10px;
    `}
`;
